import { render, staticRenderFns } from "./ChecklistDictionariesTransfer.vue?vue&type=template&id=2e25a832&scoped=true&"
import script from "./ChecklistDictionariesTransfer.vue?vue&type=script&lang=js&"
export * from "./ChecklistDictionariesTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ChecklistDictionariesTransfer.vue?vue&type=style&index=0&id=2e25a832&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e25a832",
  null
  
)

export default component.exports